import React from "react";

/**
 * Maps the many raw status strings used across the app to a consistent
 * pill badge. Pure presentation — so it can safely replace the old
 * StatusBadge wherever a status string is shown.
 */
const MAP = {
    berhasil: { tone: "success", label: "Berhasil" },
    success: { tone: "success", label: "Success" },
    sukses: { tone: "success", label: "Sukses" },
    paid: { tone: "success", label: "Paid" },
    completed: { tone: "success", label: "Completed" },
    disetujui: { tone: "success", label: "Disetujui" },
    approved: { tone: "success", label: "Approved" },
    aktif: { tone: "success", label: "Aktif" },
    active: { tone: "success", label: "Active" },

    pending: { tone: "warning", label: "Pending" },
    menunggu: { tone: "warning", label: "Menunggu" },
    waiting: { tone: "warning", label: "Waiting" },
    proses: { tone: "warning", label: "Proses" },
    processing: { tone: "warning", label: "Processing" },

    expired: { tone: "danger", label: "Expired" },
    failed: { tone: "danger", label: "Failed" },
    gagal: { tone: "danger", label: "Gagal" },
    ditolak: { tone: "danger", label: "Ditolak" },
    rejected: { tone: "danger", label: "Rejected" },
    batal: { tone: "danger", label: "Batal" },

    settlement: { tone: "primary", label: "Settlement" },
    free: { tone: "slate", label: "Free" },
};

const TONES = {
    slate: "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
    primary: "bg-primary-50 text-primary-700 ring-primary-100 dark:bg-primary-500/10 dark:text-primary-300 dark:ring-primary-500/20",
    success: "bg-success-50 text-success-700 ring-success-100 dark:bg-success-500/10 dark:text-success-400 dark:ring-success-500/20",
    warning: "bg-warning-50 text-warning-700 ring-warning-100 dark:bg-warning-500/10 dark:text-warning-400 dark:ring-warning-500/20",
    danger: "bg-danger-50 text-danger-700 ring-danger-100 dark:bg-danger-500/10 dark:text-danger-400 dark:ring-danger-500/20",
};

const SIZES = {
    sm: "px-2 py-0.5 text-[11px]",
    md: "px-2.5 py-1 text-xs",
    lg: "px-3 py-1 text-sm",
};

export default function StatusBadge({ status, size = "md", className = "" }) {
    const key = String(status ?? "").toLowerCase();
    const cfg = MAP[key] || { tone: "slate", label: status ? String(status) : "Unknown" };

    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full font-medium capitalize ring-1 ring-inset whitespace-nowrap
                ${TONES[cfg.tone]} ${SIZES[size] || SIZES.md} ${className}`}
        >
            <span className="h-1.5 w-1.5 rounded-full bg-current" />
            {cfg.label}
        </span>
    );
}
